export default "__VITE_ASSET__vTMVbzDg__"